import React from 'react';

export const DropdownMenu = ({ children, className, ...props }) => {
  return (
    <div
      className={`dropdown-menu bg-blanco-nieve border border-azul-lago shadow-lg rounded-md ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const DropdownMenuTrigger = ({ children, className, ...props }) => {
  return (
    <button
      className={`dropdown-menu-trigger bg-azul-lago text-blanco-nieve px-4 py-2 rounded-md text-sm font-medium hover:bg-azul-lago/90 transition-all ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export const DropdownMenuContent = ({ children, className, ...props }) => {
  return (
    <div
      className={`dropdown-menu-content bg-blanco-nieve border-t border-azul-lago text-azul-lago rounded-md shadow-md mt-2 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const DropdownMenuItem = ({ children, className, ...props }) => {
  return (
    <div
      className={`dropdown-menu-item text-azul-lago hover:bg-azul-lago/10 p-2 cursor-pointer rounded-md transition-all ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const DropdownMenuLabel = ({ children, className, ...props }) => {
  return (
    <div
      className={`dropdown-menu-label text-azul-lago font-semibold py-2 px-4 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const DropdownMenuSeparator = ({ className, ...props }) => {
  return (
    <div
      className={`dropdown-menu-separator border-t border-azul-lago ${className}`}
      {...props}
    />
  );
};
